import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from "vuex";
import {
    HttpWarehouseSkuOutboundsList,
    HttpWarehouse
} from '@/service/storageallocation';
export default {
    mixins: [TableList],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            warehouseList: [],
            startUp: true
        }
    },
    async mounted() {
       /*  await HttpWarehouse().then(res => {
            this.warehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.title,
                    attach: {
                        ...item
                    }
                }
            })
        }, err => {
            this.$VMessage.error(err.message);
        }) */
    },
    computed: {
        ...mapGetters("dictionary", [
            "getOrgList",
            "getBillcusorgList",
            "getBillcusAndFbaWareList",
            "getUserManageWarehouseList"
        ]),
        ToolsData() {
            return [
                {
                    name: "批量导出",
                    operate: "export",
                    theme: "info",
                    // batch: true,
                }
            ]
        },
        SearchsData() {
            let style = 'width: 130px;';
            return [
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getBillcusorgList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '日期',
                    tag: 'vDatepicker',
                    key: 'BT_generatedDate',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                    style: style
                },
            ]
        },
        
        columns() {
            return [
                 {
                    title: '客户',
                    render: (h, { row }) => {
                        let orgName = this.getBillcusorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || '--';
                        if (orgName !== '--') {
                            orgName = orgName.label;
                        }
                        return <div>{orgName}</div>
                    }
                }, {
                    title: '仓库',
                    key: 'orgWarehouseCode'
                },{
                    title: 'sku',
                    key: 'sku'
                },{
                    title: '平均出库数量',
                    key: 'outboundQty'
                },{
                    title: '平均出库体积（CBM）',
                    key: 'outboundVolume'
                }, {
                    title: '日期',
                    key: 'generatedDate'
                }]
        }
    },
    methods: {
        ajaxRequest: HttpWarehouseSkuOutboundsList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/warehouseSkuOutbounds/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        }
    }
}